/**
 * ProgressBar
 * 
 * Shows progress through the current scene
 */

import { memo } from 'react';
import styles from './progress-bar.module.css';

interface ProgressBarProps {
  progress: number; // 0-100
  className?: string;
}

export const ProgressBar = memo(({ progress, className }: ProgressBarProps) => {
  return (
    <div 
      className={`${styles.progressBarContainer} ${className || ''}`}
      role="progressbar"
      aria-valuenow={Math.round(progress)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label="Scene progress"
    >
      <div 
        className={styles.progressBar} 
        style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
      />
    </div>
  );
});

